<template>
  <div class="order-details">
    <div class="detail-list">
      <h5>{{ _T('Order Details') }}</h5>
      <ul v-if="selected_order">
        <div class="item-detail">
          <li v-for="(item, index) in selected_order.items" :key="index">
            <div class="d-flex">
              <div class="content-order">
                <h4>
                  {{ _T_DB(item, 'name')
                  }}<small v-if="item.qty > 0"> x {{ item.qty }}</small>
                </h4>
                <p v-if="itemHasDiscount(itemDiscount, item.no)">
                  <small>{{ _T('Discount') }} </small>
                </p>
                <ul>
                  <template v-for="(modifier, index) in itemModifiers">
                    <li :key="index" v-if="modifier.for_item === item.no">
                      <i class="fa-var-circle"></i>
                      <span v-if="modifier.qty > 0">x {{ modifier.qty }}</span>
                      {{ _T_DB(modifier, 'name') }}
                      <span v-if="modifier.price > 0">{{
                        Num.price(modifier.price, true)
                      }}</span>
                    </li>
                  </template>
                </ul>
                <small class="item-note" v-if="item.note"> {{_T('Note:')}} {{ item.note }}</small>
              </div>
              <h4 v-if="itemHasDiscount(itemDiscount, item.no)">
                <template v-for="(discount, key) in itemDiscount">
                  <small :key="key" v-if="discount.for_item === item.no">
                    <span class="text-capitalize font-weight-bold">
                      <!--{{ _T_DB(discount, 'name') }}-->
                    </span>
                    {{ currency }} {{ Num.price(item.price * item.qty) }} <br />
                    <small
                      >- {{ currency }} {{ Num.price(discount.price) }}</small
                    >
                    <!--{{ Num.price(item.price * item.qty - Num.price(discount.price)) }} {{ selected_order.currency }}-->
                  </small>
                </template>
              </h4>
              <h4 v-else>
                <small>
                  {{ currency }} {{ Num.price(item.price * item.qty) }}
                </small>
              </h4>
            </div>
          </li>
        </div>
        <li>
          <div class="d-flex">
            <div class="content-order">
              <h4>{{ _T('Item Total') }}</h4>
            </div>
            <h4>
              <span>{{ currency }}</span>
              {{ Num.price(selected_order.sub_total) }}
            </h4>
          </div>
        </li>
        <li v-if="selected_order.order_surcharges">
          <div
            class="d-flex"
            v-for="(order_surcharge,
            index_os) in selected_order.order_surcharges"
            :key="index_os"
          >
            <div class="content-order">
              <h4>{{ _T(order_surcharge.name) }}</h4>
            </div>
            <h4>
              <span>{{ currency }}</span>
              {{ Num.price(order_surcharge.price) }}
            </h4>
          </div>
        </li>
        <li v-if="selected_order.delivery_surcharge">
          <div class="d-flex">
            <div class="content-order">
              <h4>{{ _T('Special Delivery Surcharge') }}</h4>
            </div>
            <h4>
              <span>{{ currency }}</span>
              {{ Num.price(selected_order.delivery_surcharge) }}
            </h4>
          </div>
        </li>
        <li v-if="selected_order.tip_amount">
          <div class="d-flex">
            <div class="content-order">
              <h4>{{ _T('Driver Tip') }}</h4>
            </div>
            <h4>
              <span>{{ currency }}</span>
              {{ Num.price(selected_order.tip_amount) }}
            </h4>
          </div>
        </li>
        <li v-if="loyaltyAmount">
          <div class="d-flex">
            <div class="content-order">
              <h4>{{ _T('Paid by loyalty') }}</h4>
            </div>
            <h4>
              <span> - {{ currency }}</span>
              {{ Num.price(loyaltyAmount.collected) }}
            </h4>
          </div>
        </li>
        <li v-if="selected_order">
          <div class="d-flex">
            <div class="content-order">
              <h4>{{ _T('Tax') }}</h4>
            </div>
            <h4>
              <span>{{ currency }}</span>
              {{ Num.price(selected_order.total_tax) }}
            </h4>
          </div>
        </li>
        <li v-if="selected_order.order_discounts">
          <div
            class="d-flex"
            v-for="disocunt in selected_order.order_discounts"
            :key="disocunt.entity_id"
          >
            <div class="content-order">
              <h4>{{ _T_DB(disocunt, 'name') }}</h4>
            </div>
            <h4>
              - <span>{{ currency }}</span>
              {{ Num.price(disocunt.price) }}
            </h4>
          </div>
        </li>
        <li class="bill-amount">
          <div class="d-flex">
            <div class="content-order">
              <h4>{{ _T('Bill Amount') }}</h4>
            </div>
            <h4>
              {{ currency }}
              {{ Num.price(totalAmount) }}
            </h4>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Modifiers from "../Cart/Items/Modifiers";
import * as CONST from '@/constants'
export default {
  // components: {Modifiers},
  computed: {
    ...mapGetters(['_T', '_T_DB', 'selected_order']),
    itemModifiers() {
      // return this.selected_order.item_modifiers.find(item => item.for_item === itemNo)
      return this.selected_order.item_modifiers
    },
    itemDiscount() {
      // return this.selected_order.item_modifiers.find(item => item.for_item === itemNo)
      return this.selected_order.item_discounts
    },
    totalAmount() {
      let total_amount =
        parseFloat(this.selected_order.tip_amount) +
        parseFloat(this.selected_order.balance_due)
      if (this.loyaltyAmount) {
        return total_amount - parseFloat(this.loyaltyAmount.collected)
      }
      return total_amount
    },
    loyaltyAmount() {
      let loyalty = undefined
      if (this.selected_order.order_payments) {
        this.selected_order.order_payments.forEach(payment => {
          if (
            payment.name === CONST.PAYMENT_NAME_LOYALTY_POINTS ||
            payment.name === CONST.PAYMENT_NAME_GO_ORDER_LOYALTY_POINTS
          ) {
            loyalty = payment
          }
        })
      }
      return loyalty
    },
  },
  methods: {
    itemHasDiscount(discount, item_no) {
      return discount.find(item => item.for_item === item_no)
    },
  },
}
</script>

<style lang="scss" scoped>
.order-details {
  padding: calc(#{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
  margin-bottom: calc(
    #{$px150} + (33 - 20) * ((100vw - #{$px320}) / (1920 - 320))
  );
  border-bottom: $px2 solid $light-border;
  .detail-list {
    h5 {
      font-weight: 600;
      margin-bottom: calc(
        #{$px20} + (33 - 20) * ((100vw - #{$px320}) / (1920 - 320))
      );
    }
    ul {
      .item-detail {
        overflow: hidden;
        max-height: $px350;
        overflow-y: auto;
        border-bottom: $px2 dashed #edeff4;
        margin-bottom: $px20;
        &::-webkit-scrollbar {
          display: none;
        }
        .content-order {
          margin-bottom: $px10;
          .item-note {
            margin: $px12 $px12;
          }
          ul {
            li {
              padding-top: $px5;
              font-weight: 500;
              color: #a19d97;
            }
          }
        }
      }
      li {
        display: block;
        + li {
          padding-top: calc(
            #{$px10} + (19 - 10) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
        // &:nth-child(3), &:nth-child(6) {
        //     border-bottom: $px2 dashed $light-border;
        //     padding-bottom: calc(#{$px16} + (25 - 16) * ((100vw - #{$px320}) / (1920 - 320)));
        // }
        // &:nth-child(4), &:last-child {
        //     padding-top: calc(#{$px15} + (28 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
        // }

        > div {
          justify-content: space-between;
          align-items: center;
          h4,
          h6 {
            margin-bottom: 0;
          }
          h4 {
            font-weight: 600;
            span {
              font-weight: normal;
            }
          }
          h6 {
            letter-spacing: 0.5px;
            span {
              color: $light-font;
            }
          }
          .content-order {
            h4 {
              span {
                color: $light-font;
              }
            }
          }
        }
        &.bill-amount {
          border-top: $px2 dashed #edeff4;
          margin-top: $px20;
        }
      }
    }
  }
}
@media (max-width: 360px) {
  .order-details {
    .detail-list {
      ul {
        li {
          > div {
            .content-order {
              h4 {
                text-align: left;
              }
            }
            h4 {
              text-align: right;
            }
          }
        }
      }
    }
  }
}
.body-rtl {
  // @media (max-width: 575px) {
    .order-details { 
      .detail-list {
        ul {
          padding-right:0;
        }
      }
    }
  // }
}
</style>
